import { Participants, Chat, Settings } from './../../components';

export const useTabs = (i18n) => [
  { id: 1, name: i18n.participants.label, Icon: Participants },
  { id: 2, name: i18n.chat.label, Icon: Chat },
  { id: 3, name: i18n.settings.label, Icon: Settings },
];
